module.exports = __webpack_public_path__ + "img/fundingResolutionLogo2.d5b5ddeb.png";